<template>
    <div v-cloak>
        <div class="page-news-wrap">
            <PagesPublicHeader :active="bannar_type" :lng="lng" :lang="lang"></PagesPublicHeader>
            <div class="page-news-area" v-if="tab === '1' && sub === '11'">
                <div class="info-case1">
                    <div class="item1">
                        <BlockBaseTitle :lng="lng" :txt1="'News Updates'" :txt2="lng['新闻动态']"></BlockBaseTitle>
                    </div>
                    <div class="list">
                        <div class="list-inner">
                            <!-- <div class="item" v-for="(item, idx) in 6" :key="idx">
                                <img class="img" src="~/assets/img/bg28.png" />
                                <div class="p1">
                                    <div class="c1">{{ lng['冬至家宴，暖身更暖心'] }}</div>
                                    <div class="c2">2024.01.07</div>
                                    <div class="c3">
                                        <div class="c3-inner">
                                            <div class="d1"></div>
                                            <div class="d2">{{ lng['了解更多'] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <a class="item" v-for="(item, idx) in list.list3.list" :key="idx" :href="item.text?`${STATIC_HOST}/page/content/details/${item.id}`:'javascript:void(0);'" :target="item.text?'_blank':''">
                                <img class="img" :src="getImageSrc(item)" @error="onImgError" />
                                <div class="p1">
                                    <div class="c1" :title="item.title">{{ item.title }}</div>
                                    <div class="c2" v-show="item.time">{{ (item.time||'').substr(0,10) }}</div>
                                    <div class="c3">
                                        <div class="c3-inner" :style="{ opacity:item.text?1:0 }">
                                            <div class="d1"></div>
                                            <div class="d2">{{ lng['了解更多'] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                             <a class="item" v-for="(item, idx) in list.list3.list" :key="idx" :href="item.text?`${STATIC_HOST}/page/content/details/${item.id}`:'javascript:void(0);'" :target="item.text?'_blank':''">
                                <img class="img" :src="getImageSrc(item)" @error="onImgError" />
                                <div class="p1">
                                    <div class="c1" :title="item.title">{{ item.title }}</div>
                                    <div class="c2" v-show="item.time">{{ (item.time||'').substr(0,10) }}</div>
                                    <div class="c3">
                                        <div class="c3-inner" :style="{ opacity:item.text?1:0 }">
                                            <div class="d1"></div>
                                            <div class="d2">{{ lng['了解更多'] }}</div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="info-case2">
                    <div class="item item1">
                        <div class="p1">
                            <div class="c1">{{ lng['项目新闻'] }}</div>
                        </div>
                        <div class="item_inner">
                            <!-- <div class="list" v-for="(item, idx) in 6" :key="idx">
                                <div class="c1">
                                    <img class="img" src="~/assets/img/bg30.jpg" />
                                </div>
                                <div class="c2">{{ lng['冬至家宴，暖身更暖心'] }}</div>
                                <div class="c3">{{ lng['冬至寒岁至，每年的冬至节，力士达集团全体员工都会欢聚一堂，喝羊汤、品美食、话团圆，传承集团的红色文化。'] }}</div>
                                <div class="c4">
                                    <div class="c4-inner">
                                        <div class="d1"></div>
                                        <div class="d2">{{ lng['了解更多'] }}</div>
                                    </div>
                                </div>
                                <div class="c5">2024.01.07</div>
                            </div> -->
                            <a class="list" v-for="(item, idx) in list.list1.list" :key="idx" :href="item.text?`${STATIC_HOST}/page/content/details/${item.id}`:'javascript:void(0);'" :target="item.text?'_blank':''">
                                <div class="c1">
                                    <img class="img" :src="getImageSrc(item)" @error="onImgError" />
                                </div>
                                <div class="c2" :title="item.title">{{ item.title }}</div>
                                <div class="c3" :title="item.synopsis">{{ item.synopsis }}</div>
                                <div class="c4" v-show="item.text">
                                    <div class="c4-inner"  :style="{ opacity:item.text?1:0 }">
                                        <div class="d1"></div>
                                        <div class="d2">{{ lng['了解更多'] }}</div>
                                    </div>
                                </div>
                                <div class="c5" v-show="item.time">{{ (item.time||'').substr(0,10) }}</div>
                            </a>
                        </div>
                    </div>
                    <div class="item item2">
                        <div class="p1">
                            <div class="c1">{{ lng['集团动态'] }}</div>
                        </div>
                        <div class="item_inner">
                            <a class="list" v-for="(item, idx) in list.list2.list" :key="idx" :href="item.text?`${STATIC_HOST}/page/content/details/${item.id}`:'javascript:void(0);'" :target="item.text?'_blank':''">
                                <div class="c1">
                                    <img class="img" :src="getImageSrc(item)" @error="onImgError" />
                                </div>
                                <div class="c2" :title="item.title">{{ item.title }}</div>
                                <div class="c3" :title="item.synopsis">{{ item.synopsis }}</div>
                                <div class="c4" v-show="item.text">
                                    <div class="c4-inner"  :style="{ opacity:item.text?1:0 }">
                                        <div class="d1"></div>
                                        <div class="d2">{{ lng['了解更多'] }}</div>
                                    </div>
                                </div>
                                <div class="c5">{{ (item.time||'').substr(0,10) }}</div>
                            </a>
                            <!-- <div class="list" v-for="(item, idx) in 3" :key="idx">
                                <div class="c1">
                                    <img class="img" src="~/assets/img/bg29.jpg" />
                                </div>
                                <div class="c2">{{ lng['力士达智慧停车系统项目点亮生态金温江！'] }}</div>
                                <div class="c3">{{ lng['冬至寒岁至，每年的冬至节，力士达集团全体员工都会欢聚一堂，喝羊汤、品美食、话团圆，传承集团的红色文化。'] }}</div>
                                <div class="c4">
                                    <div class="c4-inner">
                                        <div class="d1"></div>
                                        <div class="d2">{{ lng['了解更多'] }}</div>
                                    </div>
                                </div>
                                <div class="c5">2024.01.07</div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="info-case3">
                    <div class="info-inner" style="margin-top: 5vw;">
                        <BlockLoadMore cls="custom1" v-show="list.list1.list.length>5||list.list2.list.length>0" p1="#474140" :loading="list.list1.loading||list.list2.loading" :loaded="list.list1.param.pageNum>=list.list1.pageMax&&list.list2.param.pageNum>=list.list2.pageMax" :lng="lng" @on-click="more(tab1);more('2')"></BlockLoadMore>
                    </div>
                </div>
            </div>
            <PagesPublicFooter :lng="lng" :lang="lang"></PagesPublicFooter>
        </div>
    </div>
</template>

<script>
import { PagesPublicFooter } from "#components";
import langObj from "@/utils/lang";
import noImage from "~/assets/img/no-image.png";
export default {
    async setup() {
        // 新闻动态 api:/api/content/page
        // var host = useAppConfig().API_HOST
        // const { data: dataList } = await useAsyncData('list2', async () => {
        //     const [list1, list2] = await Promise.all([
        //         $fetch(`${host}/api/content/page`,{ 
        //             method:'post',
        //             body: JSON.stringify({
        //                 pageNum: 1,
        //                 pageSize:  6,
        //                 queryModel :  {categoryId: 3,status:1}
        //             })
        //         }),
        //         $fetch(`${host}/api/content/page`,{ 
        //             method:'post',
        //             body: JSON.stringify({
        //                 pageNum: 1,
        //                 pageSize:  3,
        //                 queryModel :  {categoryId: 4,status:1}
        //             })
        //         })
        //     ])
        //     return { list1, list2 }
        // })

        // return {
        //     dataList,
        // }
    },
    computed: {
        bannar_type() {
            return 'page-news'
        },
        lng() {
            return langObj[this.lang] || langObj['zh']
        },
    },
    props: {
        tab: {
            default: '1'
        },
        sub: {
            default: '11'
        },
        lang: {
            type: String,
            default: 'zh'
        }
    },
    methods: {
        getImageSrc(item) {
            if (!item || !item.image) return noImage;
            return (item.image.indexOf('http') > -1) ? item.image : this.STATIC_HOST + item.image;
        },
        onImgError(e) {
            e.target.src = noImage;
        },
        async more(tab) {
            var opt = this.list['list'+tab]
            if (opt.loading) return;
            if (opt.param.pageNum>=opt.pageMax) return;
            opt.loading = true;
            try{
                var res = await $fetch(`${this.STATIC_HOST}/api/content/page`,{ 
                    method:'post',
                    body: JSON.stringify({ ...opt.param,pageNum:opt.param.pageNum+1  })
                })
                if (res.code==200) {
                    opt.pageMax = res.data.pages
                    opt.param.pageNum = res.data.current
                    opt.list = opt.list.concat(res.data.records)
                }
            } catch(e) {
            }
            opt.loading = false;
        },
    },
    data() {
        var that = this;
        return {
            API_HOST:useAppConfig().API_HOST,
            STATIC_HOST:useAppConfig().STATIC_HOST,
            tab1: '1',
            dataList:{},
            list:{
                list1: {
                    pageMax: 100,
                    loading: false,
                    list:[],
                    param:{
                        pageNum: 1,
                        pageSize: 10,
                        // queryModel:  {categoryId: that.lang == 'en'?44:3,status:1},
                        queryModel :  {groupCode: that.lang == 'en'?'022':'021',status:1}
                    }
                },
                list2: {
                    pageMax: 100,
                    loading: false,
                    list:[],
                    param:{
                        pageNum: 1,
                        pageSize: 5,
                        // queryModel:  {categoryId: that.lang == 'en'?45:4,status:1},
                        queryModel :  {groupCode: this.lang == 'en'?'024':'023',status:1}
                    }
                },
                list3: {
                    pageMax: 100,
                    loading: false,
                    list:[],
                    param:{
                        pageNum: 1,
                        pageSize: 15,
                        // queryModel:  {categoryId: that.lang == 'en'?45:4,status:1},
                        queryModel :  {groupCode: this.lang == 'en'?'026':'025',status:1}
                    }
                },
            }
        }
    },
    async mounted() {
        if (typeof window !== 'undefined') {
            if (this.tab === '1') {
                this.t1 = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".info-case1 .block_base_title",
                        // endTrigger: '.info-case1 .p2',
                        start: "top bottom",
                        end: "bottom top",
                        // scrub: true,
                        // markers: true,
                        id: ".info-case1 .block_base_title",
                        toggleActions: "restart none none none"
                    }
                })
                this.t1.fromTo(".info-case1 .block_base_title", { y: 100, opacity: 0 }, {
                    y: 0, opacity: 1
                })
            }
            // container.classList.remove('lang_zh');
            // container.classList.remove('lang_en');
            // container.classList.add(`lang_${this.lang}`);
        }

        var host = useAppConfig().STATIC_HOST
        const [list1, list2, list3] = await Promise.all([
            $fetch(`${host}/api/content/page`,{ 
                method:'post',
                body: JSON.stringify({
                    pageNum: 1,
                    pageSize:  10,
                    // queryModel :  {categoryId: this.lang == 'en'?44:3,status:1}
                    queryModel :  {groupCode: this.lang == 'en'?'022':'021',status:1}
                })
            }),
            $fetch(`${host}/api/content/page`,{ 
                method:'post',
                body: JSON.stringify({
                    pageNum: 1,
                    pageSize:  5,
                    // queryModel :  {categoryId: this.lang == 'en'?44:4,status:1}
                    queryModel :  {groupCode: this.lang == 'en'?'024':'023',status:1}
                })
            }),
            $fetch(`${host}/api/content/page`,{ 
                method:'post',
                body: JSON.stringify({
                    pageNum: 1,
                    pageSize:  15,
                    queryModel :  {groupCode: this.lang == 'en'?'026':'025',status:1}
                })
            })
        ])
        this.list.list1.list = list1.data.records || []
        this.list.list1.pageMax = list1.data.pages
        this.list.list1.param.pageNum = list1.data.current

        this.list.list2.list = list2.data.records || []
        this.list.list2.pageMax = list2.data.pages
        this.list.list2.param.pageNum = list2.data.current

        this.list.list3.list = list3.data.records || []
        this.list.list3.pageMax = list3.data.pages
        this.list.list3.param.pageNum = list3.data.current
    },
    beforeUnmount() {
        if (this.t1) this.t1.kill();
    }
}
</script>
<style lang="scss">
.mobile-layout {
    .page-news-area {
        .info-case1 {}
    }
}

@keyframes move1 {
    100% {
        // transform: translateX(-138.3vw);
        transform: translateX(-87vw);
    }
}

.lang_en{
    .page-news-area .info-case1 .list .list-inner .item .p1 .c1{
        font-size: 0.83vw;
    }
    .page-news-area .info-case1 .list .list-inner .item .p1 .c2{
        font-size: 0.66vw;
        margin-top: 0.4vw;
    }
    .page-news-area .info-case1 .list .list-inner .item .p1{
        padding: 0.96vw 1.61458vw;
    }

    .page-news-area .info-case2 .item .item_inner .c2{
        font-size: 0.83vw;
        text-overflow: initial;
        white-space: initial;
        overflow: hidden;
    }
    .page-news-area .info-case2 .item .item_inner .c3{
        -webkit-line-clamp: 8;
        height: auto;
        font-size: 0.66vw;
    }
}

.page-news-area {
    overflow-x: hidden;
    .info-case1 {
        padding-bottom: 7.552vw;
        overflow: hidden;

        .list {

            .list-inner {
                display: flex;
                animation: move1 20s linear infinite;
                transition: transform 0.5s ease-in-out;

                &:hover {
                    animation-play-state: paused;
                }

                .item {
                    display: block;
                    // width: 46.40625vw;
                    width: 36.40625vw;
                    box-sizing: border-box;
                    padding: 0 1.5625vw;
                    position: relative;
                    text-decoration: none;
                    color: #333;

                    &:hover .p1 {
                        display: block;
                    }


                    .p1 {
                        background: #f7e28b;
                        width: 25.26vw;
                        min-height: 7.552vw;
                        box-sizing: border-box;
                        padding: 1.61458vw;
                        border-radius: 10px;
                        position: absolute;
                        bottom: -4.16vw;
                        left: 0;
                        display: none;

                        .c1 {
                            font-size: 1.0583vw;
                            // text-align: justify;
                        }

                        .c2 {
                            font-size: 1.0416vw;
                        }

                        .c3 {
                            margin-top: -2vw;

                            .c3-inner {
                                padding-top: 0.36vw;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-end;
                                padding-right: 0.78125vw;

                                .d1 {
                                    width: 2.34375vw;
                                    height: 0.9375vw;
                                    background: url(~/assets/img/c3.png) no-repeat;
                                    background-size: 100% auto;
                                    cursor: pointer;
                                }

                                .d2 {
                                    color: #423a32;
                                    font-size: 0.625vw;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }

                .img {
                    // width: 42.8125vw;
                    width: 26vw;
                    height: 100%;
                    overflow: hidden;
                    object-fit: cover;
                    border-radius: 10px;
                }
            }
        }
    }

    .info-case2 {
        display: flex;
        justify-content: space-between;

        .item {
            display: flex;
            flex-direction: column;

            .p1 {
                display: flex;

                .c1 {
                    background: #f3f4f4;
                    border-radius: 20px 20px 0 0;
                    color: #233963;
                    font-size: 1.875vw;
                    padding: 1.1458vw 2.76vw;
                    position: relative;

                    &::after {
                        content: ' ';
                        display: block;
                        background: url(~/assets/img/c1.png) bottom right no-repeat;
                        background-size: auto 100%;
                        width: 2.6vw;
                        height: 100%;
                        position: absolute;
                        right: -2.6vw;
                        bottom: 0;
                    }
                }


            }

            .item_inner {
                background: #f3f4f4;
                border-radius: 0 20px 0 0;
                padding-top: 2.65625vw;

                .list {
                    background: #fff;
                    border: 1px solid #cacaca;
                    border-radius: 10px;
                    position: relative;
                    box-sizing: border-box;
                    padding: 0.625vw;
                    display: block;
                    text-decoration: none;
                    color: #333;
                    
                    &:hover {
                        .c1{
                            .img {
                                transform: scale(1.3);
                            }
                        }
                    }
                }

                .c1 {
                    height: 13.541vw;
                    width: 100%;
                    overflow: hidden;
                    border-radius: 8px;
                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1);
                        transition: all 0.8s;
                    }
                }

                .c2 {
                    font-size: 1.1458vw;
                    font-weight: 600;
                    line-height: 1.1;
                    padding: 0.9375vw 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 23.43vw;
                }

                .c3 {
                    font-size: 0.833vw;
                    height: 4vw;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    // text-align: justify;
                }

                .c4 {
                    .c4-inner {
                        padding-top: 0.36vw;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        padding-right: 0.78125vw;

                        .d1 {
                            width: 2.34375vw;
                            height: 0.9375vw;
                            background: url(~/assets/img/c2.png) no-repeat;
                            background-size: 100% auto;
                            cursor: pointer;
                        }

                        .d2 {
                            color: #2d416a;
                            font-size: 0.625vw;
                            cursor: pointer;
                        }
                    }
                }

                .c5 {
                    position: absolute;
                    z-index: 3;
                    left: 1.5625vw;
                    top: -1.3vw;
                    border: 1px solid #999a9a;
                    background: #e3e3e3;
                    padding: 0.3vw 1.04vw;
                    font-size: 0.9375vw;
                    line-height: 1;
                }
            }
        }

        .item1 {
            .item_inner {
                display: grid;
                grid-template-columns: repeat(2,1fr);
                min-width: 52vw;
                column-gap: 2.916vw;
                row-gap: 7.916vw;
                margin-right: 1.1458vw;

                padding-left: 4.427vw;
                padding-right: 2.08vw;
                padding-bottom: 15vw;

                .c1 {
                    .img {}
                }

                .list {}
            }
        }

        .item2 {
            .item_inner {
                min-width: 30vw;
                padding-left: 2.08vw;
                padding-right: 4.6875vw;
                flex: 1;

                .list {
                    margin-bottom: 3.958vw;
                }

                .c1 {
                    width: inherit;
                    height: 17.1875vw;
                    .img {}
                }
                .c2{
                    width: 30vw;
                }
            }
        }
    }

    .info-case3 {
        position: relative;

        .info-inner {
            position: absolute;
            left: 0;
            right: 0;
            z-index: 3;
            top: -15vw;
        }
    }
}
</style>